import { Feature, Polygon } from "geojson";
import { useMemo } from "react";
import { useUtilitiesBufferLayer } from "react-migration/domains/map/layers/useUtilitiesBufferLayer";
import { addBufferToGeometry } from "react-migration/domains/sites/helpers/addBufferToGeometry";
import { Stores, useGlobalState, useMapLayer } from "react-migration/lib";
import { SelectionType } from "src/js/stores/map/store";

export function useUtilitiesBuffer() {
  const [
    {
      selection,
      settings: { showSiteUtilityReport },
    },
  ] = useGlobalState(Stores.map);
  const [_, { setUtilityGeometry }] = useGlobalState(Stores.site);

  const data: Feature<Polygon> | null = useMemo(() => {
    let data = selection?.feature;

    if (selection?.type === SelectionType.LAT_LNG) {
      /**
       * Map layer is already handled by pin for LAT/LNG selections.
       */
      data = undefined;
    }

    if (selection?.__renderGeometry) {
      /**
       * Workaround for when the selection geometry (used for intersections)
       * doesn't match what needs to be rendered. e.g. Planning dots
       */
      data = selection.__renderGeometry;
    }

    if (!data?.geometry || !showSiteUtilityReport) {
      return null;
    }

    return addBufferToGeometry(data?.geometry);
  }, [selection?.__renderGeometry, selection?.feature, selection?.type, showSiteUtilityReport]);

  setUtilityGeometry(data?.geometry);

  const layer = useUtilitiesBufferLayer(data);

  useMapLayer(
    () => ({
      layer,
      zOrder: 2147483646,
    }),
    [layer]
  );
}
